import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { FormGroup } from '@angular/forms';

@Injectable()

export class ValidationService {

  requiredfield(form: FormGroup, name: string): boolean {
    if (form.get(name).errors && form.get(name).errors.required && form.get(name).dirty) {
      return true;
    }
    return false;
  }
  patternfield(form: FormGroup, name: string): boolean {
    if (form.get(name).errors && form.get(name).errors.pattern && form.get(name).dirty) {
      return true;
    }
    return false;
  }
  minlengthfield(form: FormGroup, name: string): boolean {
    if (form.get(name).errors && form.get(name).errors.minlength && form.get(name).dirty) {
      return true;
    }
    return false;
  }

  maxlengthfield(form: FormGroup, name: string): boolean {
    if (form.get(name).errors && form.get(name).errors.maxlength && form.get(name).dirty) {
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/interface/UIValidation.ts